import { faArrowRight, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../../Components/Context';

const DistributionFond = ({open, setOpen, data = {amount : 100, poucentage : 10, app : 0, ownerId : 1}}) => {
  
  console.log(data)
  const navigator = useNavigate()
  const [totalAmount, setTotalAmount] = useState(data.amount); // Exemple de montant total payé
  const [ownerPercentage, setOwnerPercentage] = useState(data.poucentage); // Pourcentage pour le propriétaire
  const [appAmount, setAppAmount] = useState(((10*data.amount) / data.poucentage));
  const [ownerAmount, setOwnerAmount] = useState(data.ownerId);
  const { actifItem, setActifItem } = useContext(MyContext);

  useEffect(()=>{
    setActifItem('Distributions')
  }, [])

  
  // Fonction pour calculer la distribution des fonds
  const handleDistribution = () => {
    const ownerShare = (totalAmount * ownerPercentage) / 100;
    const appShare = totalAmount - ownerShare;
    
    setOwnerAmount(ownerShare.toFixed(2));
    setAppAmount(appShare.toFixed(2));
  };

  // Validation de la distribution
  const confirmDistribution = () => {
    alert(`Distribution confirmée :
      Application: ${appAmount} €
      Propriétaire: ${ownerAmount} €
    `);
    // Logique pour valider la distribution (API call ou autre)
  };

  return open ? (
    <div id="modal" aria-hidden={open} className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-900 bg-opacity-80">
      <div className="max-w-lg p-6 mx-auto bg-gray-800 rounded-lg shadow-lg animate-fade">
        {/* Header du Modal */}
        <div className="flex items-center justify-between">
          <span
            className="flex items-center justify-center w-8 h-8 text-gray-300 transition-colors duration-200 bg-gray-700 rounded-full cursor-pointer hover:bg-red-600"
            onClick={() => setOpen(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </span>

          <span
            className="flex items-center justify-center px-4 py-2 text-sm font-semibold text-gray-300 transition-colors duration-200 bg-blue-600 rounded-lg cursor-pointer hover:bg-blue-700"
            onClick={() => navigator(`/reservation/details/${data.paiement.reservation.id}`)}
          >
            <span className="mr-2">Réservation</span>
            <FontAwesomeIcon icon={faArrowRight} />
          </span>
        </div>

        {/* Paiement Section */}
        {data.paiement && (
          <div className="my-6">
            <h2 className="mb-4 text-xl font-bold text-white">Paiement :</h2>
            <div className="px-5 py-4 bg-gray-700 border-l-4 border-blue-500 rounded-md">
              <div className="text-gray-300">
                <p className="mb-2">Client : {data.paiement.clientName}</p>
                <p className="mb-2">Montant : {data.paiement.transaction.amount} {data.paiement.transaction.currency}</p>
                <p className="mb-2">MOBILE MONEY MSIDSN : {data.paiement.transaction.msisdn}</p>
                <p className="mb-2">XReference : {data.paiement.transaction.XReference}</p>
                <p>Date : {new Date(data.paiement.transaction.createdAt).toLocaleDateString()}</p>
              </div>
            </div>
          </div>
        )}

        {/* Retribution Section */}
        <div className="my-6">
          <h2 className="mb-4 text-xl font-bold text-white">Rétribution :</h2>
          {data.transaction ? (
            <div className="px-5 py-4 bg-gray-700 border-l-4 border-green-500 rounded-md">
              <div className="text-gray-300">
                <p className="mb-2">Montant : {data.transaction.amount} {data.transaction.currency}</p>
                <p className="mb-2">MOBILE MONEY MSIDSN : {data.transaction.msisdn}</p>
                <p className="mb-2">XReference : {data.transaction.XReference}</p>
                <p className="mb-2">Date : {new Date(data.transaction.createdAt).toLocaleDateString()}</p>
                <p>Commission : {data.commission}%</p>
              </div>
            </div>
          ) : (
            <div className="px-5 py-4 text-yellow-300 bg-gray-700 rounded-md">
              <p>Rétribution en attente</p>
            </div>
          )}
        </div>
      </div>
    </div>


  ) : null;
};

export default DistributionFond;
